import { ChangeDetectorRef, Component, ErrorHandler, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, inject, signal } from '@angular/core'
import { Router } from '@angular/router'

import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'

import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { TilintarkastajaComponentDataResolve } from 'app/_angular/_resolvers/tilintarkastaja.resolve'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { Tilintarkastaja } from 'app/_jaettu-lemonator/model/tilintarkastaja'
import { TilintarkastajaUriService } from 'app/_jaettu-lemonator/service/tilintarkastaja-uri.service'
import { TILINTARKASTAJAN_TILA_TEKSTI } from 'app/_jaettu-lemonator/service/tilintarkastaja.service'

@Component({
  templateUrl: './tilintarkastajat.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TilintarkastajatComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort, { static: true }) _sort: MatSort

  private ngUnsubscribe: Subject<void> = new Subject<void>()
  dataSource = new MatTableDataSource<Tilintarkastaja>([])
  readonly loading = signal(true)
  private readonly _changeDetectorRef = inject(ChangeDetectorRef)

  displayedColumns: string[] = ['aktiivinen', 'etunimi', 'sukunimi', 'email', 'tila']
  readonly TILINTARKASTAJAN_TILA_TEKSTI = TILINTARKASTAJAN_TILA_TEKSTI

  constructor(
    private router: Router,
    private errorHandler: ErrorHandler,
    private _firebase: FirebaseLemonator,
    private _tilintarkastajaUriService: TilintarkastajaUriService,
    private _tilintarkastajaComponentDataResolve: TilintarkastajaComponentDataResolve,
  ) {
    this.dataSource.sortData = (data: Tilintarkastaja[], sort: MatSort): Tilintarkastaja[] => {
      const active = sort.active
      const direction = sort.direction

      if (!active || direction === '') {
        return data
      }

      const directionMultiplier = direction === 'asc' ? 1 : -1

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

      if (active === 'etunimi') {
        return data.sort((a, b) => {
          return collator.compare(a.etunimi, b.etunimi) * directionMultiplier
        })
      }

      if (active === 'sukunimi') {
        return data.sort((a, b) => {
          return collator.compare(a.sukunimi, b.sukunimi) * directionMultiplier
        })
      }

      if (active === 'aktiivinen') {
        return data.sort((a, b) => {
          return (a.poistettu === b.poistettu ? 0 : a.poistettu ? -1 : 1) * directionMultiplier
        })
      }

      if (active === 'email') {
        return data.sort((a, b) => {
          return collator.compare(a.email, b.email) * directionMultiplier
        })
      }

      return data
    }
  }

  ngOnInit() {
    this._sort.sort({ id: 'sukunimi', start: 'asc', disableClear: false })
    this.dataSource.sort = this._sort

    this._firebase
      .firestoreCollection<Tilintarkastaja>(this._tilintarkastajaUriService.annaTilintarkastajaCollectionUri())
      .listen()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        list => {
          this.dataSource.data = list || []
          this.loading.set(false)
          this._changeDetectorRef.markForCheck()
        },
        err => this.errorHandler.handleError(err),
      )
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  lisaa() {
    this.router.navigate(['yllapito', 'tilintarkastajat', 'uusi'])
  }

  muokkaa(t: Tilintarkastaja) {
    this._tilintarkastajaComponentDataResolve.asetaOlemassaolevaData({ tilintarkastaja: t })
    this.router.navigate(['yllapito', 'tilintarkastajat', t.avain])
  }
}
